import { render, staticRenderFns } from "./NetaHeaderComponent.vue?vue&type=template&id=8fa78d9e&scoped=true&"
import script from "./NetaHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./NetaHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaHeaderComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaHeaderComponent.vue?vue&type=style&index=1&id=8fa78d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa78d9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fa78d9e')) {
      api.createRecord('8fa78d9e', component.options)
    } else {
      api.reload('8fa78d9e', component.options)
    }
    module.hot.accept("./NetaHeaderComponent.vue?vue&type=template&id=8fa78d9e&scoped=true&", function () {
      api.rerender('8fa78d9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/NetaHeaderComponent.vue"
export default component.exports